// fetchWithAuth.js
// 공통 API 베이스
const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:8000";

// ──[A] 브라우저 지문: 한 번 계산 후 캐시 ─────────────────────────────
let __FP_CACHE = null;
async function computeFingerprintHash() {
  if (__FP_CACHE) return __FP_CACHE;
  const nav = window.navigator || {};
  const data = [
    nav.userAgent || "",
    nav.language || "",
    nav.platform || "",
    String(nav.hardwareConcurrency || ""),
    String(nav.deviceMemory || ""),
    `${window.screen?.width || ""}x${window.screen?.height || ""}`,
    String(new Date().getTimezoneOffset()),
  ].join("|");
  const enc = new TextEncoder().encode(data);
  const digest = await crypto.subtle.digest("SHA-256", enc);
  const hex = Array.from(new Uint8Array(digest)).map(b => b.toString(16).padStart(2, "0")).join("");
  __FP_CACHE = hex;
  return hex;
}

// ──[B] 비회원 세션 초기화: 로컬 anon_id 없으면 /anon/init 호출 ─────────
async function ensureAnonymousSession() {
  let anonId = localStorage.getItem("anon_id") || "";
  const fp = await computeFingerprintHash();

  // 이미 anon_id가 있으면 빠르게 종료
  if (anonId) return { anonId, fp };

  const res = await fetch(`${API_BASE_URL}/anon/init`, {
    method: "POST",
    credentials: "include", // httpOnly 쿠키 수신
    headers: {
      "Content-Type": "application/json",
      "X-Anonymous-ID": anonId,   // 빈 문자열 가능
      "X-Fingerprint": fp,
    },
  });

  if (!res.ok) throw new Error("anonymous init failed");
  const data = await res.json();
  if (!data?.anon_id) throw new Error("anon_id missing");

  anonId = data.anon_id;
  localStorage.setItem("anon_id", anonId);
  return { anonId, fp };
}

// ──[C] 공통 fetch 래퍼 ───────────────────────────────────────────────
export const fetchWithAuth = async (url, options = {}) => {
  // 1) 비회원 세션 준비(로컬스토리지 비워져 있어도 자동 복원/신규발급)
  const { anonId, fp } = await ensureAnonymousSession();

  // 2) 기본 헤더 구성
  const token = localStorage.getItem("token");
  const headers = new Headers(options.headers || {});
  if (token) headers.set("Authorization", `Bearer ${token}`);

  // Content-Type: FormData 업로드면 자동 설정에 맡김
  const isFormData = options.body instanceof FormData;
  if (!isFormData && !headers.has("Content-Type")) {
    headers.set("Content-Type", "application/json");
  }

  // 비회원 추적용 공통 헤더
  headers.set("X-Anonymous-ID", anonId || "");
  headers.set("X-Fingerprint", fp);

  // 3) 실제 요청
  const res = await fetch(`${API_BASE_URL}${url}`, {
    ...options,
    headers,
    credentials: "include", // 쿠키 동반(복원에 필요)
  });

  // 4) 세션 만료 처리(회원용)
  if (res.status === 401) {
    localStorage.removeItem("token");
    localStorage.removeItem("nickname");
    localStorage.removeItem("userInfo");
    alert("세션이 만료되었습니다. 다시 로그인해주세요.");
    window.location.href = "/login";
    return null;
  }

  return res;
};
